import { ca } from '@cian/analytics';

export function trackModalOpen(label?: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Message_popup',
    action: 'open',
    label,
    useLastProducts: true,
  });
}
